import { useCallback } from "react";

export const useKendoGridHandlers = (setGridState) => {
  const HandleDataStateChange = useCallback(
    (event) => {
      const newSort = event.dataState.sort;
      if (newSort.length > 0) {
        setGridState((prev) => ({
          ...prev,
          sort: newSort,
        }));
      }
    },
    [setGridState]
  );

  const HandlePageChange = useCallback(
    (params) => {
      if (params.nativeEvent.type === "input") {
        return;
      }
      const pageNumber = Math.floor(params.page.skip / params.page.take) + 1;
      const pageSize = params.page.take;
      setGridState((prevState) => ({
        ...prevState,
        pageNumber,
        pageSize,
      }));
    },
    [setGridState]
  );

  return { HandleDataStateChange, HandlePageChange };
};
